export default __webpack_public_path__ + "static/media/blue-icon.49103bb5.svg";